import { AlarmsModel } from "./AlarmsModel";

export class ChannelModel {
  constructor(
    public id: number,
    public name: string,
    public group: string,
    public details: string,
    public channelType: string,
    public deviceName: string,
    public lastWatermarkId: number,
    public status: string,
    public alarms: AlarmsModel,
    public mediaLogLevel: number,
    public lastTimestamp?: Date,
  ) { }
}
